import {getDataFromApi} from 'Utils/apiUtils';
import {axaStore} from 'Store/index';
import {updateClient} from 'Store/navigation/navigation.action';

const useProfileEndpoint = 'user-profile';

export const getUserProfile = async () => {
    const data = await getDataFromApi(useProfileEndpoint);
    axaStore.dispatch(updateClient(data));
};
